import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPIHousien } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export type PlanWaitlistItem = {
  plan_key: string;
  joined_at: string;
};

export type PlanWaitlistListResponse = {
  items: PlanWaitlistItem[];
};

export type PlanWaitlistJoinInput = {
  plan_key: string;
};

/**
 * OpenAPI client for the plan waitlist feature.
 */
export class PlanWaitlistService {
  /**
   * Join the waitlist for a sold-out plan. Idempotent.
   */
  public static join(requestBody: PlanWaitlistJoinInput): CancelablePromise<unknown> {
    return __request(OpenAPIHousien, {
      method: 'POST',
      url: '/plan-waitlist',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * List waitlisted plans for the authenticated user.
   */
  public static list(): CancelablePromise<PlanWaitlistListResponse> {
    return __request(OpenAPIHousien, {
      method: 'GET',
      url: '/plan-waitlist',
    });
  }
}
